import { Database } from 'libs/end-to-end/src/types/databases/database';
import { z } from 'zod';

export const CreateOrUpdateDatabaseRequestBodySchema = Database.omit({
  id: true,
});

export type CreateOrUpdateDatabaseRequestBodyType = z.infer<
  typeof CreateOrUpdateDatabaseRequestBodySchema
>;
